import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp16};
  padding: ${props => props.theme.spacing.sp16};
  border: ${props => props.theme.stroke.default} solid ${props => props.theme.colors.border.subtle};
  border-radius: ${props => props.theme.primitives.radius.radius4};
`

export const ProductHeader = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp8};
  align-items: center;
`

export const ProductInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp4};
`

export const ProductImage = styled.img`
  height: ${props => props.theme.size.XL};
  width: ${props => props.theme.size.XL};
  aspect-ratio: 1/1;
  object-fit: contain;
  border-radius: ${props => props.theme.primitives.radius.radius2};
  flex-shrink: 0;
`

export const CodeRows = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp24};
`
